// Libs
import { createSlice } from '@reduxjs/toolkit';
import { createIncident, deleteIncident } from './incidentSlice';
// Others

export interface IIncidentState {
  isRefreshIncidentList: boolean;
}

export const initialState: IIncidentState = {
  isRefreshIncidentList: true,
};

const incidentSlice = createSlice({
  name: 'incident',
  initialState,
  reducers: {
    setRefreshIncidentList(state, action) {
      state.isRefreshIncidentList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // POST: Create incident
    builder
      .addCase(createIncident.pending, (_state) => {})
      .addCase(createIncident.fulfilled, (_state) => {})
      .addCase(createIncident.rejected, (_state) => {});

    // DELETE: delete incident
    builder
      .addCase(deleteIncident.pending, (_state) => {})
      .addCase(deleteIncident.fulfilled, (_state) => {})
      .addCase(deleteIncident.rejected, (_state) => {});
  },
});

// Action
export const incidentActions = incidentSlice.actions;

// Selectors

// Reducer
const incidentReducer = incidentSlice.reducer;
export default incidentReducer;
